import { pipe } from 'remeda';
import { NEW_CORE_ID } from '../../../config/constants';
import type { StoreState } from '../../state-types';
import { useStore } from '../../use-store';
import { addCard } from '../cards/add-card';
import { updateUiCoreQuestionForm } from '../ui-core-question-form/update-ui-core-question-form';

/**
 * Create a new Core Question to the state.
 * - Note: In the app, edit/create a core question equals to edit/create a linear question.
 * */
export const createCoreQuestion = (state: StoreState) => {
    const actions = state.actions;
    const okToCreate = actions.checkIsOkToSwitchCoreQuestionForm();

    if (!okToCreate) {
        return;
    }

    // Pipe several actions to create a new core question
    const newState2 = pipe(
        state,
        // create new linear question FE State with core question id
        addCard('linearQuestion', undefined, {
            id: NEW_CORE_ID,
        }),
        // Set form ui active and pristine, switch to new core question
        updateUiCoreQuestionForm({
            // let the new question is inactive by default
            isActive: false,
            isDirty: false,
        })
    );

    useStore.setState(newState2, true);
};
